'use client';

import React from 'react'

const DummyImage = "https://images.unsplash.com/photo-1568605114967-8130f3a36994?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

const ImageCard = ({ className, ...props }) => {
  return (
    <div className={`max-w-[370px] min-w-[370px] mr-2 last:mr-0 ${className}`}>
      <img
        {...props}
        alt='Images'
        width="auto"
        height="auto"
        className='w-full h-full object-cover rounded-3xl'
      />
    </div>
  )
}
const ImageCardMobile = () => {
  return (
    <div className='hidden w-full overflow-scroll scrollbar-hide h-[208px] 
    dd-lg:flex'>
      <div className="max-w-[117px] min-w-[117px] h-full mr-2">
        <img
          src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/main.png"}
          alt='Images'
          width="auto"
          height="auto"
          className='w-full h-full object-cover rounded-3xl'
        />
      </div>

      <ImageCard src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/2.png"} />
      <ImageCard src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/3.png"} />
      <ImageCard src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/4.png"} />
      <ImageCard src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/5.png"} />
      <ImageCard src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/6.png"} />
    </div>
  )
}

export default ImageCardMobile